import { Box, CircularProgress } from '@mui/material'
import { Auth } from 'aws-amplify'
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { FC, useEffect, useRef } from 'react'

export type ManagedLoginRedirectProps = {
  /**
   * Opaque data (JSON-stringified) to carry through the Cognito Hosted UI
   * redirect round-trip, e.g. where to land the user afterwards. Read back
   * on `/sso/callback` via the `customOAuthState` Hub event.
   */
  customState?: string
}

/**
 * Immediately redirects to Cognito Hosted UI on mount
 */
export const ManagedLoginRedirect: FC<ManagedLoginRedirectProps> = ({
  customState,
}) => {
  // Make sure to redirect only once per mount when running on local
  const hasRedirected = useRef(false)

  useEffect(() => {
    if (hasRedirected.current) return
    hasRedirected.current = true

    void Auth.federatedSignIn({
      provider: CognitoHostedUIIdentityProvider.Cognito,
      customState,
    })
  }, [customState])

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
      <CircularProgress data-testid="managed-login-redirecting" />
    </Box>
  )
}
